const SETUP_DEFERRED_KEY = "aireport.workspace.setup.deferred";

export function isSetupDeferred(): boolean {
  try {
    return localStorage.getItem(SETUP_DEFERRED_KEY) === "1";
  } catch {
    return false;
  }
}

export function deferSetup(): void {
  try {
    localStorage.setItem(SETUP_DEFERRED_KEY, "1");
  } catch {
    // ignore storage errors
  }
}

export function clearSetupDeferred(): void {
  try {
    localStorage.removeItem(SETUP_DEFERRED_KEY);
  } catch {
    // ignore storage errors
  }
}
